import Err from "./Err";
export default Err;
